import { useTranslation } from "react-i18next";

import { Dropdown, DropdownButton, DropdownContent } from "@aviary";
import { DropdownLink, OpenAction } from "@aviary/components/Dropdown";
import { emersonRoutes } from "@emerson/data/emersonRoutes";
import { l } from "@emerson/locales/i18n";
import { getParamsString } from "@shared/hooks/useUrlParams/useUrlParams";

import * as navStyles from "../Navigation/Navigation.styles";

const DROPDOWN_NAME = "Quality";

type Props = {
  toggleCallback: (dropdown: string) => (isOpen: boolean) => void;
  openDropdown: string;
};

const QualityDropdown = ({ toggleCallback, openDropdown }: Props) => {
  const { t } = useTranslation();

  const getEQPPath = () => {
    const eqpParams = getParamsString({
      eqpLevels: ["Gold", "Silver"],
    });

    return `${emersonRoutes.shop.catalog}?${eqpParams}`;
  };

  return (
    <Dropdown
      openAction={OpenAction.HOVER}
      dropdownPlacement="bottom-start"
      isOpen={openDropdown === DROPDOWN_NAME}
      toggleCallback={toggleCallback(DROPDOWN_NAME)}
    >
      <div css={navStyles.dropdownButtonBorder}>
        <DropdownButton css={navStyles.dropdownButton} isText hasIcon={false}>
          {t(l.header.Quality.Header)}
        </DropdownButton>
      </div>
      <DropdownContent css={navStyles.dropdownContent}>
        <DropdownLink noExternalIcon href={emersonRoutes.external.quality.about}>
          {t(l.header.Quality.About)}
        </DropdownLink>
        <DropdownLink noExternalIcon to={getEQPPath()}>
          {t(l.header.Quality.QualityPartners)}
        </DropdownLink>
      </DropdownContent>
    </Dropdown>
  );
};
export { QualityDropdown };
